export default "__VITE_ASSET__BnXGmts4__"